"use client";
import { cva as e } from "class-variance-authority";
import { input as t } from "./input.js";
const i = e("", {
  variants: {
    slot: {
      trigger: [
        t({ size: "md", variant: "outline" }),
        "px-4 py-0 flex items-center justify-between"
      ],
      content: [
        "relative z-dropdown max-h-96 min-w-[8rem]",
        "overflow-hidden rounded-md border",
        "bg-white dark:bg-gray-dark-950 shadow-md",
        "data-[state=open]:animate-fade-in data-[state=closed]:animate-fade-out",
        "data-[side=bottom]:translate-y-1.5",
        "data-[side=left]:-translate-x-1.5",
        "data-[side=right]:translate-x-1.5",
        "data-[side=top]:-translate-y-1.5"
      ],
      viewport: [
        "p-1 h-[var(--radix-select-trigger-height)]",
        "w-full min-w-[var(--radix-select-trigger-width)]"
      ],
      item: [
        "hover:bg-gray-100 dark:hover:bg-gray-dark-800",
        "focus:bg-gray-100 dark:focus:bg-gray-dark-800",
        "relative flex w-full text-md cursor-pointer py-1.5",
        "select-none outline-none pl-2 pr-8 rounded-md items-center ",
        "data-[disabled]:pointer-events-none data-[disabled]:opacity-50"
      ],
      itemIndicator: ["absolute right-2 flex h-3.5 w-3.5", "items-center justify-center"]
    }
  }
});
export {
  i as select
};
